import {Injectable, PipeTransform, Pipe} from '@angular/core';

import {
  isBlank,
  isString,
  isNumber,
  isFunction,
  RegExpWrapper,
  StringWrapper
} from '../facade/lang';

import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class ReplacePipe implements PipeTransform {
  transform(value: any, pattern: string | RegExp, replacement: Function | string): any {
    if (isBlank(value)) {
      return value;
    }

    if (!this._supportedInput(value)) {
      throw new InvalidPipeArgumentException(ReplacePipe, value);
    }

    var input = value.toString();

    if (!this._supportedPattern(pattern)) {
      throw new InvalidPipeArgumentException(ReplacePipe, pattern);
    }
    if (!this._supportedReplacement(replacement)) {
      throw new InvalidPipeArgumentException(ReplacePipe, replacement);
    }
    // template fails with literal RegExp e.g /pattern/igm
    // var rgx = pattern instanceof RegExp ? pattern : RegExpWrapper.create(pattern);

    if (isFunction(replacement)) {
      var rgxPattern = isString(pattern) ? RegExpWrapper.create(<string>pattern) : <RegExp>pattern;

      return StringWrapper.replaceAllMapped(input, rgxPattern, <Function>replacement);
    }
    if (pattern instanceof RegExp) {
      // use the replaceAll variant
      return StringWrapper.replaceAll(input, pattern, <string>replacement);
    }

    return StringWrapper.replace(input, <string>pattern, <string>replacement);
  }

  private _supportedInput(input: any): boolean { return isString(input) || isNumber(input); }

  private _supportedPattern(pattern: any): boolean {
    return isString(pattern) || pattern instanceof RegExp;
  }

  private _supportedReplacement(replacement: any): boolean {
    return isString(replacement) || isFunction(replacement);
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'replace'}, ] },
{ type: Injectable },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
